import { useState, useEffect, useRef } from 'react';
import { promotionImgMb_01, promotionImgMB_02, promotionImg_01, promotionImg_02} from '../utils'
const ImageSwitcher = ({isMobile}) => {
  // 状态管理：控制当前显示的图片索引
  const [currentIndex, setCurrentIndex] = useState(0);
  // 引用DOM元素
  const imageRefs = useRef([]);

  // 图片资源数组
  const pcImages = [
    { src: promotionImg_01, alt: "chip 01" },
    { src: promotionImg_02, alt: "chip 02" }
  ];
  const mbImages = [
    { src: promotionImgMb_01, alt: "chipmb 01" },
    { src: promotionImgMB_02, alt: "chipmb 02" }
  ];
  const images = isMobile? mbImages : pcImages
  // 切换图片的函数
  const switchImage = () => {
    // 隐藏当前图片
    imageRefs.current[currentIndex].classList.remove('opacity-100');
    imageRefs.current[currentIndex].classList.add('opacity-10');
    
    // 计算下一张图片的索引
    const nextIndex = (currentIndex + 1) % images.length;
    
    // 短暂延迟后显示下一张图片，确保淡出动画完成
    setTimeout(() => {
      setCurrentIndex(nextIndex);
      imageRefs.current[nextIndex].classList.remove('opacity-10');
      imageRefs.current[nextIndex].classList.add('opacity-100');
    }, 1000); // 与过渡时间一致
  };

  // 设置定时器，每隔1秒切换一次图片
  useEffect(() => {
    const interval = setInterval(switchImage, 3000);
    
    // 组件卸载时清除定时器
    return () => clearInterval(interval);
  }, [currentIndex]);

  return (
    <div id="chip" className="flex items-center justify-center w-full relative overflow-hidden" style={{minHeight:isMobile?'68px':'318px',background:'#e5ecfe'}}>
      {/* 图片容器使用相对定位，让图片叠在一起 */}
      {images.map((img, index) => (
        <img
          key={index}
          ref={el => imageRefs.current[index] = el}
          src={img.src}
          alt={img.alt}
          className={`absolute transition-opacity duration-1000 ease-in-out 
                     ${index === currentIndex ? 'opacity-100' : 'opacity-0'}
                     w-[100vw] h-auto sm:w-full sm:h-full`}
        />
      ))}
    </div>
  );
};

export default ImageSwitcher;
